"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var deleteItemRequest_1 = require("owa-service/lib/factory/deleteItemRequest");
var itemId_1 = require("owa-service/lib/factory/itemId");
var deleteItemOperation_1 = require("owa-service/lib/operation/deleteItemOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
function createItemIdForRequest(itemIdType) {
    return itemId_1.default({
        Id: itemIdType.Id,
        ChangeKey: itemIdType.ChangeKey,
    });
}
function configureRequestBody(itemIds, disposalType) {
    return deleteItemRequest_1.default({
        ItemIds: itemIds.map(function (itemId) { return createItemIdForRequest(itemId); }),
        DeleteType: disposalType,
        SuppressReadReceipts: true,
        ReturnMovedItemIds: true,
        SendMeetingCancellations: 'SendToNone',
        AffectedTaskOccurrences: 'AllOccurrences',
    });
}
function deleteItemService(itemIds, disposalType, requestInitOptions) {
    var requestBody = configureRequestBody(itemIds, disposalType);
    return deleteItemOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: requestBody,
    }, requestInitOptions).then(function (response) {
        return response.Body.ResponseMessages.Items;
    });
}
exports.default = deleteItemService;
//# sourceMappingURL=deleteItemService.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-store/lib/services/deleteItemService.js
// module id = 2148
// module chunks = 1 3 4 62 108